__turbopack_context__.v({
  "actions": "OqfbDq_actions",
  "footer": "OqfbDq_footer",
});
